import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectActivePage, selectBannersSpaceHeight } from 'master-pages/stores/master-pages-slice-handler';
import { updateCssVar } from 'utils/layout-manager';
import { MasterPageType } from '../../constants/top-bar-constants';
import MasterPageSettings from './master-page-settings';
import MasterPageContacts from './master-page-contacts';

/**
 * Render the details of a user asynchronously.
 * @param {string} msisdn
 * @return {JSX.Element|null}
 * @constructor
 */
export default function MasterPagesManager() {
    /**
     * @type {MasterPageType}
     */
    const activePage = useSelector(selectActivePage);

    /**
     * NOTE: This is a TEMPORARY solution until the call/channels banners will be integrated in WCFUI.
     * When the banners will be integrated, this component will publish a container which will work on its own and will force the bannersSpaceHeight.
     * That is the reason why the margin top which makes room for banners space is hard-coded here and is not under CSS.
     * @type {number}
     */
    const bannersSpaceHeight = useSelector(selectBannersSpaceHeight);

    // alter the CSS variable which holds the height of banner space heigh
    // NOTE: This is a TEMPORARY hack.
    useEffect(() => {
        updateCssVar('--MASTER_PAGE_BANNERS_SPACE_HEIGHT', `${bannersSpaceHeight}px`);
    }, [bannersSpaceHeight]);

    if (activePage === null) {
        return null;
    }

    switch (activePage) {
        case MasterPageType.SETTINGS:
            return <MasterPageSettings />;

        case MasterPageType.CONTACTS:
            return <MasterPageContacts />;

        default:
            return null;
    }
}
